import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, Spin } from 'antd';
import { observer } from 'mobx-react';
import FormComponent from './FormComponent';
import { Notification } from '../../../../config/Global';
import Message from '../../../../config/Message';
import useStore from '../../../../store';

const EditComponent = observer((props) => {
	const { visible, onClose } = props;
	const [disabled, setDisabled] = useState(true);
	const [saving, setSaving] = useState(false);
	const [form] = Form.useForm();
	const { ADMINSETTINGS, ROOT } = useStore();
	const { adminSettingsDetail } = ADMINSETTINGS;

	const handleSubmit = (data) => {
		setSaving(true);
		ADMINSETTINGS.EditAdimnSettings({
			...data,
			id: adminSettingsDetail.id,
			versionNo: adminSettingsDetail.versionNo,
		})
			.then(() => {
				ADMINSETTINGS.adminSettingsDetail = null;
				Notification.success({
					message: Message().CRUD.UPDATE('Admin Setting'),
				});
				closeModal();
			})
			.catch((e) => {
				const errorData = ROOT.assignErrorToInput(e);
				form.setFieldsValue({ error: errorData });
			})
			.finally(() => setSaving(false));
	};

	const handleChange = () => {
		setTimeout(() => {
			form.validateFields({ validateOnly: true })
				.then(() => {
					setDisabled(false);
				})
				.catch(() => {
					setDisabled(true);
				});
		}, 0);
	};

	useEffect(() => {
		if (visible && adminSettingsDetail) {
			form.setFieldsValue({
				settingKey: adminSettingsDetail.settingKey,
				settingName: adminSettingsDetail.settingName,
				settingValue: adminSettingsDetail.settingValue,
				settingdbType: adminSettingsDetail.settingdbType,
			});
		}
	}, [visible, adminSettingsDetail]);

	const closeModal = async () => {
		setDisabled(true);
		ADMINSETTINGS.adminSettingsDetail = null;
		form.resetFields();
		onClose();
	};
	return (
		<Modal
			title="Edit Admin Settings"
			onCancel={closeModal}
			open={visible}
			destroyOnClose
			width={'500px'}
			footer={
				<div>
					<Button
						type="primary"
						key={1}
						disabled={disabled}
						htmlType="submit"
						loading={saving}
						form="EditForm"
					>
						Update Settings
					</Button>
					<Button key={2} onClick={closeModal}>
						Cancel
					</Button>
				</div>
			}
		>
			<Spin spinning={!ADMINSETTINGS.adminSettingsDetail}>
				<FormComponent
					id="EditForm"
					form={form}
					onFinish={handleSubmit}
					handleChange={handleChange}
				/>
			</Spin>
		</Modal>
	);
});
export default EditComponent;
